import React from "react"

import { Text } from "ui-kit/components-branded/index"
import { SocialButton } from "modules/ClientAccount/components/ReferralLinkWidget/SocialButton"
import { APP_PAGE_URL } from "utils/env-management"

export function ButtonsGroup({
    shareTitle,
    className,
    urlForShare,
}: {
    shareTitle: string
    className?: string
    urlForShare?: string
}) {
    const url = urlForShare ?? APP_PAGE_URL
    return (
        <div className={className}>
            <Text isAccent className="mgb-3 is-inline-block">
                Или отправьте в&nbsp;личных сообщениях
            </Text>
            <div className="is-flex justify-content-between">
                <SocialButton
                    name="Telegram"
                    link={`https://telegram.me/share/url?url=${encodeURIComponent(
                        url
                    )}&text=${shareTitle}`}
                    icon="telegram-green-circle"
                />
                <SocialButton
                    name="VKontakte"
                    link={`https://vk.com/share.php?url=${encodeURIComponent(
                        url
                    )}&title=${shareTitle}`}
                    icon="vk"
                />
            </div>
        </div>
    )
}
